export default "__VITE_ASSET__c5975a0c__"